export const initialResetPassword = {
  email: '',
};
